/**
 * @module cercaliagl/view/VZBEPopup
 */

import $ from 'jquery';
import BaseView from './BaseView';
import { i18n } from '../dictionary';

/**
 * @typedef {Object} ZBEInfo
 * @property {number} [id]
 * @property {string} [a8_name]
 * @property {string} [info]
 * @property {string} [zbe_name]
 */

/**
 * @classdesc
 */
class VZBEPopup extends BaseView {
  /**
   * @constructor
   */
  constructor() {
    const jqElement = $('<div class="v-zbepopup mdc-elevation--z4"></div>');

    super(jqElement);

    /**
     * @private
     * @type {ZBEInfo}
     */
    this.info_ = null;
  }

  /**
   * @private
   */
  render_() {
    const html = `
    <div class="header">
      <span>${this.info_.zbe_name}</span>
    </div>
    <div class="zbe-content">
      <div class="address">
        <a target=_blank class="zbe-link" href=${this.info_.info}>
        ${this.info_ ? `${i18n('ZBEInfo')}<br/>` : ''}
        </a>
      </div>
    </div>
    <div class="actions">
      <button type="button" class="mdc-button ok"><span class="mdc-button__ripple"></span>OK</button>
    </div>`;

    this.jqElement_
      .empty()
      .append(html);

    this.show();
    this.initialize_();
  }

  /**
   * @private
   */
  initialize_() {
    this.jqElement_.find('button.ok').click(() => this.hide());
  }

  /**
   * @param {ZBEInfo} info ZBE Info
   */
  update(info) {
    this.info_ = info;
    this.render_();
  }
}

export default VZBEPopup;
